/**
 * Enum representing the supported data types for model values.
 */
export enum EnumDataTypes {
  /**
   * Date and time data type.
   */
  DateTime = 'dt',

  /**
   * Globally unique identifier (GUID) data type.
   */
  Guid = 'g',

  /**
   * String data type.
   */
  String = 's',

  /**
   * Numeric data type.
   */
  Number = 'n'
}



